// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pilote-modal[data-v-0748509f] {
  position: relative;
  width: 450px;
  padding: 20px;
  background-color: white;
  border-radius: 3px;
}
.pilote-modal-header[data-v-0748509f] {
  display: flex;
  flex-direction: column;
  padding-right: 25px;
}
.pilote-modal h3[data-v-0748509f] {
  font-size: 17px;
}
.pilote-modal-exit[data-v-0748509f] {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 5px;
  background-color: white;
  border: none;
  border-radius: 2px;
  cursor: pointer;
}
.pilote-modal-exit[data-v-0748509f]:hover {
  background-color: #eee;
}
.pilote-modal-divider[data-v-0748509f] {
  margin-top: 15px;
  margin-bottom: 25px;
  height: 1px;
  width: 100%;
  background-color: #e6e6e6;
}
.pilote-modal-body[data-v-0748509f] {
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.pilote-modal-footer[data-v-0748509f] {
  padding-top: 25px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 4px;
}
.padding-left[data-v-0748509f] {
  margin-left: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/components/generic/modal/PiloteModal.vue"],"names":[],"mappings":";AAgEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["<template>\n  <NModal :show=\"show\" :on-esc=\"close\">\n    <div class=\"pilote-modal\">\n      <PiloteIcon icon=\"exit\" fill=\"#9C9CA0\" class=\"pilote-modal-exit\" @click=\"close\" />\n\n      <div v-if=\"title\" class=\"pilote-modal-header\">\n        <h3>\n          <b>{{ title }}</b>\n        </h3>\n\n        <div class=\"pilote-modal-divider\" />\n      </div>\n\n      <div class=\"pilote-modal-body\">\n        <slot></slot>\n      </div>\n\n      <div v-if=\"confirmLabel || closeLabel\" class=\"pilote-modal-footer\">\n        <NButton v-if=\"closeLabel\" @click=\"close\">{{ closeLabel }}</NButton>\n        <NButton v-if=\"confirmLabel\" type=\"primary\" :disabled=\"disableConfirm\" class=\"padding-left\" @click=\"confirm\">\n          {{ confirmLabel }}\n        </NButton>\n      </div>\n    </div>\n  </NModal>\n</template>\n\n<script setup>\nimport { NButton, NModal } from 'naive-ui';\nimport PiloteIcon from '../PiloteIcon.vue';\n\ndefineProps({\n  show: {\n    type: Boolean,\n    required: true,\n  },\n  title: {\n    type: String,\n    default: '',\n  },\n  confirm: {\n    type: Function,\n    default: () => {},\n  },\n  confirmLabel: {\n    type: String,\n    default: '',\n  },\n  disableConfirm: {\n    type: Boolean,\n    default: false,\n  },\n  close: {\n    type: Function,\n    required: true,\n  },\n  closeLabel: {\n    type: String,\n    default: '',\n  },\n});\n</script>\n\n<style scoped>\n.pilote-modal {\n  position: relative;\n  width: 450px;\n  padding: 20px;\n  background-color: white;\n  border-radius: 3px;\n}\n\n.pilote-modal-header {\n  display: flex;\n  flex-direction: column;\n  padding-right: 25px;\n}\n\n.pilote-modal h3 {\n  font-size: 17px;\n}\n\n.pilote-modal-exit {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  padding: 5px;\n  background-color: white;\n  border: none;\n  border-radius: 2px;\n  cursor: pointer;\n}\n\n.pilote-modal-exit:hover {\n  background-color: #eee;\n}\n\n.pilote-modal-divider {\n  margin-top: 15px;\n  margin-bottom: 25px;\n  height: 1px;\n  width: 100%;\n  background-color: #e6e6e6;\n}\n\n.pilote-modal-body {\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n\n.pilote-modal-footer {\n  padding-top: 25px;\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 4px;\n}\n\n.padding-left {\n  margin-left: 15px;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
